import { Chip, ChipProps } from '@mui/material';
import PersonRemoveOutlinedIcon from '@mui/icons-material/PersonRemoveOutlined';

/** Visible label of the manual-unassignment designator (chip and Scheduler grid pill). */
export const MANUAL_UNASSIGNMENT_LABEL = 'Manually unassigned';

/** Test id shared by the chip and the Scheduler grid pill. */
export const MANUAL_UNASSIGNMENT_TEST_ID = 'manual-unassignment-chip';

/**
 * SVG path of MUI `PersonRemoveOutlined` (copied from
 * `@mui/icons-material/PersonRemoveOutlined`), for surfaces that cannot render
 * a React icon, such as the Bryntum Scheduler grid template.
 */
export const PERSON_REMOVE_OUTLINED_SVG_PATH =
  'M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4m-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2M2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4m2 0c.2-.71 3.3-2 6-2 2.69 0 5.77 1.28 6 2zm13-8h6v2h-6z';

// Marks a task whose adjuster was removed by a person or an external system.
// Deliberately silent: no tooltip or title, and it never names who or when.
// Outlined info blue, not the Forced chip's red wash, so the two person-icon
// chips stay distinguishable. The details header passes filled/medium, as it
// does for MethodOfInspectionChip: outlined info blue is unreadable on it.
export const ManualUnassignmentChip = ({
  variant = 'outlined',
  size = 'small',
}: Pick<ChipProps, 'variant' | 'size'>) => (
  <Chip
    label={MANUAL_UNASSIGNMENT_LABEL}
    size={size}
    variant={variant}
    color="info"
    icon={<PersonRemoveOutlinedIcon />}
    data-testid={MANUAL_UNASSIGNMENT_TEST_ID}
  />
);
